{
  "forms": {
    "confirmation": {
      "thank_you": "Thank you",
      "default_message": "Thank you for submitting the form. Your information has been successfully received.",
      "redirect_message": "You are being redirected to",
      "nexl_branding": "This form was created using Nexl. Explore",
      "learn_more": "to learn more"
    }
  }
}
